import { useTranslation } from 'react-i18next';
import { useState, useRef } from 'react';
import { useDrop } from 'react-dnd';
import { NativeTypes } from 'react-dnd-html5-backend';
import { Button, Spinner, Checkbox } from '@teo/components';
import { axios } from '@/axios';
import { config } from '@/config';
import { uploadVideo } from '@/query/vimeo';

export const UploadVideo = ({ setNewAsset, closeModal }) => {
  const { t } = useTranslation();
  const fileInputVideoRef = useRef(null);
  const [isUpload, setIsUpload] = useState(false);
  const [isAutoplay, setIsAutoplay] = useState(false);
  const [isLoop, setIsLoop] = useState(false);

  const tryHandleUploadVideo = async (file) => {
    let title;
    try {
      title = file.name.split('.').slice(0, -1).join('.');
    } catch (e) {
      title = document.title;
    }
    const data = await uploadVideo(
      file,
      (progress, percent) => {
        console.warn(percent, '%');
      },
      () => {
        console.warn('All done');
      },
      title
    );
    let newUrl = data;
    if (isLoop) {
      if (newUrl.includes('?')) {
        newUrl += `&loop=1`;
      } else {
        newUrl += `?&loop=1`;
      }
    }
    if (isAutoplay) {
      if (newUrl.includes('?')) {
        newUrl += '&autoplay=1&muted=1&#t=0s';
      } else {
        newUrl += '?&autoplay=1&muted=1&#t=0s';
      }
    }

    const dataVideo = await axios.post(`${config.backend}/assets`, {
      assetName: t('pages.create_edit_course.new_asset'),
      assetType: 'video',
      assetPath: newUrl,
    });
    setIsUpload(false);
    setNewAsset(dataVideo?.data);
    closeModal();
  };

  const handleFileDrop = async (item) => {
    if (item) {
      setIsUpload(true);
      await tryHandleUploadVideo(item.files[0]);
    }
  };

  const handleUploadVideo = async (event) => {
    setIsUpload(true);
    const img = event.target.files[0];
    await tryHandleUploadVideo(img);
  };

  const [{ canDrop, isOver }, drop] = useDrop(
    () => ({
      accept: [NativeTypes.FILE],
      drop(item) {
        if (handleFileDrop) {
          handleFileDrop(item);
        }
      },
      canDrop(item) {
        return true;
      },
      hover(item) {
        // console.log('hover', item.files, item.items);
      },
      collect: (monitor) => {
        const item = monitor.getItem();
        if (item) {
          // console.log('collect', item.files, item.items);
        }

        return {
          isOver: monitor.isOver(),
          canDrop: monitor.canDrop(),
        };
      },
    }),
    [handleFileDrop]
  );
  const isActive = canDrop && isOver;

  return (
    <div>
      {!isUpload && (
        <>
          <div
            ref={drop}
            contentEditable="false"
            className="
                    flex
                    flex-col
                    items-center
                    justify-center
                    rounded-lg
                    bg-grey-02
                    px-3 py-8
                "
          >
            <div className="flex items-center" contentEditable="false">
              <img
                src="/images/icons/image.svg"
                alt="image"
                className="mr-3"
                contentEditable="false"
              />
              <span
                className="text-base font-black font-medium"
                contentEditable="false"
              >
                {t('pages.create_edit_course.video_upload_modal.add_video')}
              </span>
            </div>

            {isActive ? (
              <div
                className="my-4 text-sm font-normal text-grey-08"
                contentEditable="false"
              >
                {t('pages.upload_dropzone_section.drag_text_2')}
              </div>
            ) : (
              <div
                className="my-4 text-sm font-normal text-grey-08"
                contentEditable="false"
              >
                {t(
                  'pages.create_edit_course.video_upload_modal.add_video_text'
                )}
              </div>
            )}
            <Button
              contentEditable="false"
              variant="outline"
              size="md"
              onClick={() => {
                fileInputVideoRef?.current?.click();
              }}
              className="bg-grey-02"
            >
              {t('pages.create_edit_course.video_upload_modal.btn_select')}
            </Button>

            <input
              type="file"
              ref={fileInputVideoRef}
              onChange={handleUploadVideo}
              accept="video/mp4,video/x-m4v,video/*"
              style={{ display: 'none' }}
              multiple={false}
            />
          </div>
          <div className="mt-6 flex items-center">
            <div className="mr-4 flex items-center border-r pr-4">
              <Checkbox
                id="autoplay"
                onChange={() => setIsAutoplay(!isAutoplay)}
                checked={isAutoplay}
              />

              <label htmlFor="autoplay" className="pl-2.5 text-sm text-black">
                {t('pages.create_edit_course.video_upload_modal.autoplay')}
              </label>
            </div>
            <div className="flex items-center">
              <Checkbox
                id="loop"
                onChange={() => setIsLoop(!isLoop)}
                checked={isLoop}
              />

              <label htmlFor="loop" className="pl-2.5 text-sm text-black">
                {t('pages.create_edit_course.video_upload_modal.loop')}
              </label>
            </div>
          </div>
        </>
      )}
      {isUpload && (
        <div
          className="
              flex
              h-44
              flex-col
              items-center
              justify-center
              rounded-lg
              bg-grey-02
              px-3 py-8
          "
        >
          <Spinner
            ariaLabel="Loading spinner"
            className="h-8 w-8 border-secondary-04"
          />
        </div>
      )}
    </div>
  );
};
